import { Pipe, PipeTransform } from '@angular/core';
import { GalaxyCurrencyPipe } from '@vendasta/galaxy/pipes';
import { convertCentsToDollars } from '@vendasta/shared';

@Pipe({
  name: 'currencyWithoutUSD',
  standalone: false,
})
export class CurrencyWithoutUSDPipe extends GalaxyCurrencyPipe implements PipeTransform {
  transform(value: number, currencyCode = 'USD', locale?: string): string {
    const valueInDollars = convertCentsToDollars(value);
    const currentValue = super.transform(valueInDollars, currencyCode, locale);

    return currentValue.replace('USD', '').trim();
  }
}
